var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { SpinnerLoader } from '../../loaders/SpinnerLoader';
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: #fff;\n  opacity: 0.8;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1500;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  display: ", ";\n  align-items: center;\n  justify-content: center;\n"], ["\n  background: #fff;\n  opacity: 0.8;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1500;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  display: ", ";\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var show = _a.show;
    return (show ? 'flex' : 'none');
});
export var OverlayLoader = function (_a) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.timeoutLimit, timeoutLimit = _c === void 0 ? 2 : _c, timeoutAction = _a.timeoutAction;
    var loaderTimeout = useRef(null);
    useEffect(function () {
        if (isLoading) {
            loaderTimeout.current = setTimeout(timeoutAction, timeoutLimit * 1000);
        }
        else if (loaderTimeout.current) {
            clearTimeout(loaderTimeout.current);
        }
    }, [isLoading, timeoutLimit]);
    return (<Overlay id="overlay" show={isLoading}>
      <SpinnerLoader />
    </Overlay>);
};
var templateObject_1;
